/**
 * Puts back the columns a table was rendered without (see
 * `useConditionallyHiddenColumns`), each right after the column it followed in
 * `fullColumns`, so saving the table's view change can't drop them for good.
 */
export function restoreHiddenColumns<TColumn extends { id: string }>({
    changedColumns,
    fullColumns,
}: {
    changedColumns: TColumn[];
    fullColumns: TColumn[];
}): TColumn[] {
    const restoredColumns = [...changedColumns];
    for (const [index, column] of fullColumns.entries()) {
        if (restoredColumns.some(({ id }) => id === column.id)) {
            continue;
        }
        const previousColumn = fullColumns
            .slice(0, index)
            .findLast((candidate) =>
                restoredColumns.some(({ id }) => id === candidate.id),
            );
        const insertAt = previousColumn
            ? restoredColumns.findIndex(({ id }) => id === previousColumn.id) +
              1
            : 0;
        restoredColumns.splice(insertAt, 0, column);
    }
    return restoredColumns;
}
